module.exports = __webpack_public_path__ + "static/media/contest.20775e51.png";